enum RewriteStatusFilterType {
  PERSONALIZED = 'Personalized',
  NOT_PERSONALIZED = 'NotPersonalized',
  REWRITE_IN_ERROR = 'RewriteInError',
}

export default RewriteStatusFilterType;
